module.exports = __webpack_public_path__ + "static/point.0cd2a8a7.png";